import { createSelector } from 'reselect';

export const getLanguage =
  createSelector(
    [(state)=>state.language], 
    language=>language,
    {
      devModeChecks: {identityFunctionCheck: 'never'}
    }
  );